import { render } from "./giraffe.vue?vue&type=template&id=2a13b64c"
import script from "./giraffe.vue?vue&type=script&lang=js"
export * from "./giraffe.vue?vue&type=script&lang=js"
script.render = render

export default script